module.exports = __webpack_public_path__ + "media/images/game_icon/vi/BC4062-b29fc1e66df3d03115059a17c31d1ec1.png";